import { alpha, makeStyles, Theme, Typography } from '@material-ui/core';
import clsx from 'clsx';
import { ImageDescription } from 'components/structures/general';
import {
  careerBgSvg,
  careerImage,
  careerImage2x,
  ContactUsBlock1,
  greenSquareIcon,
  reliableSolutionsImage,
  reliableSolutionsImage2x,
} from 'images/contact-us';
import { careersBgSvg } from 'images/services';
import { NextPage } from 'next';
import React from 'react';
import { useNetworkStatus } from 'react-adaptive-hooks/dist/index.umd.js';
import { ContactForm, ContactUsBlock, MapSlider } from 'templates/contact-us';
import { SEO } from 'templates/layout';

const useStyles = makeStyles((theme: Theme) => ({
  imageWrapper: {
    position: 'relative',
  },
  imageClass: {
    [theme.breakpoints.up('md')]: {
      position: 'static',
      borderRadius: theme.spacing(0, 4),
    },
  },
  borderImage: {
    [theme.breakpoints.up('md')]: {
      display: 'block',
      position: 'absolute',
    },
  },
  borderImage0: {
    [theme.breakpoints.up('md')]: {
      width: '66%',
      height: '68%',
      bottom: theme.spacing(-3),
      left: theme.spacing(-4),
      borderLeft: `20px solid ${theme.palette.switchedColors.main}`,
      borderBottom: `20px solid ${theme.palette.switchedColors.main}`,
      borderRadius: theme.spacing(0, 2),
    },
  },
  imageClass1: {
    [theme.breakpoints.up('md')]: {
      maxWidth: 'calc(100% - 70px)',
      marginLeft: 'auto',
      display: 'block',
      margin: theme.spacing(0, 'auto'),
    },
  },
  borderImage1: {
    [theme.breakpoints.up('md')]: {
      left: 15,
      width: '50%',
      top: -15,
      height: '43%',
      borderLeft: `40px solid ${theme.palette.switchedColors.main}`,
      borderTop: `30px solid ${theme.palette.switchedColors.main}`,
      borderRadius: theme.spacing(0, 4),
      backgroundColor: theme.palette.switchedColors.main,
      zIndex: -1,
    },
  },
  miniSquare: {
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'block',
      maxWidth: 95,
      width: '100%',
      position: 'absolute',
      right: 5,
      bottom: 35,
    },
    [theme.breakpoints.up('lg')]: {
      maxWidth: 120,
      bottom: -35,
    },
  },
  underContentTextWrapper: {
    marginTop: theme.spacing(4),
    [theme.breakpoints.up('md')]: {
      marginTop: 0,
      minHeight: 100,
    },
    [theme.breakpoints.up('lg')]: {
      minHeight: 120,
    },
  },
  underContentText: {
    fontSize: 'calc(40px + 30vw)',
    lineHeight: '100px',
    color: alpha(theme.palette.common.white, 0.05),
    [theme.breakpoints.up('sm')]: {
      fontSize: 200,
      lineHeight: 0.5,
    },
    [theme.breakpoints.up('md')]: {
      fontSize: 250,
      lineHeight: 0.8,
      position: 'absolute',
      left: 0,
      bottom: 2,
    },
    [theme.breakpoints.up('lg')]: {
      fontSize: 300,
    },
  },
}));

const ContactUs: NextPage = () => {
  const classes = useStyles();
  const { effectiveConnectionType } = useNetworkStatus('3g'); // initial Param

  console.log(effectiveConnectionType);

  return (
    <>
      <SEO
        title="Contact Us"
        description="Get in touch with our software solutions company - a handy way to chat for businesses and public organizations as well as enthusiastic IT whizzes."
      />
      <ContactUsBlock
        title={'Contact Us'}
        image={ContactUsBlock1}
        upperTitle={'Let’s talk!'}
        text={"We're always ready to answer any questions! Give us a heads-up, and let's chat!"}
        titleBg={'Get in Touch'}
      />
      <ContactForm />
      <MapSlider />
      {/* <ImageDescription
        align="right"
        image={{
          image: futuresImage,
          srcSet: `${futuresImage} 578w, ${futuresImage2x} 1156w`,
          imageClass: classes.imageClass,
          imageWrapperClass: classes.imageWrapper,
          imageElements: <div className={clsx(classes.borderImage, classes.borderImage0)} />,
        }}
        bgImage={{ image: futureBgSvg }}
        upperTitle="Join our team!"
        title="Your Future With US"
        text="Join the ever-growing team and contribute to developing the cutting-edge solutions. We have an opportunity for you, you have the required skills for us?"
        link={{ href: '#', text: 'Head on over and apply!' }}
        gridItems={{ imageLg: 5, imageMd: 6, contentLg: 6, contentMd: 6 }}
      /> */}
      <ImageDescription
        image={{
          image: careerImage,
          srcSet: `${careerImage} 542w, ${careerImage2x} 1084w`,
          imageClass: clsx(classes.imageClass, classes.imageClass1),
          imageWrapperClass: classes.imageWrapper,
          imageElements: (
            <>
              <div className={clsx(classes.borderImage, classes.borderImage1)} />
              <img className={classes.miniSquare} src={greenSquareIcon} alt="square bg" />
            </>
          ),
        }}
        bgImage={{ image: careerBgSvg }}
        upperTitle="Join our team!"
        title="Your Future With US"
        text="Join the ever-growing team and contribute to developing the cutting-edge solutions. We have an opportunity for you, you have the required skills for us?"
        link={{ href: '/careers', text: 'Head on over and apply!' }}
        gridItems={{ imageLg: 5, imageMd: 6, contentLg: 6, contentMd: 6 }}
      />
      <ImageDescription
        align="right"
        image={{
          image: reliableSolutionsImage,
          srcSet: `${reliableSolutionsImage} 706w, ${reliableSolutionsImage2x} 1412w`,
        }}
        bgImage={{ image: careersBgSvg }}
        bgColor="#116666"
        onlyWhiteText
        fullImage
        showRedCircleIcon
        upperTitle="Reliable solutions"
        title="Enjoy the Best Industry Solutions"
        text="US Software Solutions delivers IT Engineering services for energy Efficiency, Renewable Energy, Utilities, and the Telecom industries."
        link={{ href: '/company', text: 'Discover more' }}
      >
        <div className={classes.underContentTextWrapper}>
          <Typography variant="h1" component="span" className={classes.underContentText}>
            usss
          </Typography>
        </div>
      </ImageDescription>
    </>
  );
};

export default ContactUs;
